import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
	getSettingsUsers,
	UpdateStatusSettingsUser,
} from '../../../../../../services/settings/users';
import { useSearchParams } from 'react-router-dom';

const useUsers = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [bulkAction, setBulkAction] = useState([]);
	const [usersList, setUsersList] = useState([]);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Users');
	const [loader, setLoder] = useState(false);
	const [sortDirection, setSortDirection] = useState({});

	const [params, setParams] = useState({
		page: Number(searchParams.get("page")) || 1,
		pageSize: Number(searchParams.get("pageSize")) || 10000,
		orderBy: searchParams.get("orderBy") || "",
		sortBy: searchParams.get("sortBy") || "",
		filterBy: searchParams.get("filterBy") || "",
		filterValue: searchParams.get("filterValue")||""
	});
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const onRowClick = (id) => {};
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};
	const handleFilterData = (type, value, key) => {
		setParams((prev) => ({
			...prev,
			filterBy: key,
			filterValue: value,
		}));
		setHeaderDropDown(type);
	};

	const handleDisable = async (e, id, status) => {
		try {
			e.stopPropagation();
			const data = {
				is_active: status,
			};
			const res = await UpdateStatusSettingsUser(data, id);
			if (res.success) {
				toast.success(res.message);
				getUsersList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.organisation_user_id,
				user: JSON.stringify({
					id: ele.organisation_user_id,
					name: `${ele.first_name} ${ele.last_name}`,
					phone_number: ele.phone_number,
					email: ele.email,
					is_active: ele.is_active,
				}),
				role: ele.role !== null && ele.role !== undefined ? ele.role.name : 'N/A',
				action: JSON.stringify({
					id: ele.organisation_user_id,
					is_active: ele.is_active,
				}),
			};
		});
	}
	const getUsersList = async () => {
		try {
			setLoder(true);
			const { users } = await getSettingsUsers(params);
			const data = mappedTableData(users);
			setUsersList(data);
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		} finally {
			setLoder(false);
		}
	};

	const setHeaderDropdownStatus = (filters) => {
			const statusMap = {
				'active': 'Active Users',
				'inactive': 'Inactive Users',
				'free': 'Free Users',
				'paid': 'Paid Users',
			};
			if (filters) {
				setHeaderDropDown(statusMap[filters]);
			}
		}
	


const setFilterFromUrl = () => {
		setSortDirection({
			[searchParams.get("orderBy")]: searchParams.get("sortBy") || "",
		});
		setHeaderDropdownStatus(searchParams.get('filterValue'));
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		url.set("page", params.page);
		url.set("pageSize", params.pageSize);
		url.set(
			"orderBy",
			params.orderBy
		);
		url.set(
			"sortBy",
			params.sortBy
		);
		url.set(
			"filterBy",
			params.filterBy
		);
		url.set(
			"filterValue",
			params.filterValue
		);
		setSearchParams(url);
	}

	useEffect(() => {
		setUrlSearchParams()
	}, [params]);

	useEffect(() => {
		getUsersList();
	}, [searchParams]);
	return {
		usersList,
		getUsersList,
		headerDropDown,
		setHeaderDropDown,
		loader,
		sortDataList,
		sortDirection,
		handleFilterData,
		bulkAction,
		setBulkAction,
		onRowClick,
		handleDeselectAll,
		handleDisable,
	};
};
export default useUsers;
